import apiClient from "./apiClient";

const schoolServices = {
  getSchoolData: () => {
    return apiClient.get("/school-admin");
  },
  getSchoolStats: () => {
    return apiClient.get("/school-stats");
  },
  getTeachersBySchool: (
    schoolId,
    { page = 1, per_page = 20, sort_by = "name", sort_dir = "asc", search = "" } = {}
  ) => {
    let url = schoolId ? `/teachers-by-school/${schoolId}` : "/teachers-by-school";
    const params = new URLSearchParams({ page, per_page, sort_dir, sort_by });

    if (search) {
      params.append("search", search);
    }

    return apiClient.get(`${url}?${params.toString()}`);
  },
  generateGeneralReport: () => {
    return apiClient.get(`/school-report`, {
      responseType: "blob",
    });
  },
  getGradesBySchool: () => {
    return apiClient.get(`/school-grades`);
  },
  getSchoolAccountManager: () => {
    return apiClient.get(`/school-account-manager`);
  },
  getCoursesBySchool: () => {
    return apiClient.get(`/school-program`);
  },
  addNewTeacher: (payload) => {
    return apiClient.post("/teachers", payload);
  },
  getSchoolTopTenStudents: () => {
    return apiClient.get(`/school-top-students`);
  },
  getSchoolTopTenStudentsByClassroom: (classroomId) => {
    return apiClient.get(`/top-students-classroom/${classroomId}`);
  },
  getSchoolStudentsLimitation: () => {
    return apiClient.get("/school-students-limitation");
  },
};

export default schoolServices;
